import { useState, type VoidFunctionComponent } from 'react';
import { ListGroupItem } from 'react-bootstrap';
import type { NoticeMatch } from '../../../../shared/types/routes/revisions';
import { FormGroup, icons, LabeledMultiTextInput, LabeledTextArea } from '../../generic';
import Button from '../../generic/Button';

import styles from './ManageNoticeFile.module.less';

type Props = {
  file: NoticeMatch;
  onChange: (change: NoticeMatch) => void;
};

const ManageNoticeFile: VoidFunctionComponent<Props> = ({ file, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ListGroupItem key={file.id}>
      <div className={styles.fileName}>{file.path}</div>
      <div className={styles.controls}>
        <Button
          type="secondary"
          size="medium"
          icon={file.ignored ? icons.eyeRegular : icons.eyeSlashRegular}
          onClick={() => onChange({ ...file, ignored: !file.ignored })}
        >
          {file.ignored ? 'Stop Ignoring' : 'Ignore'}
        </Button>
        <Button
          size="medium"
          icon={isOpen ? icons.minusSquareO : icons.pencil}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? 'Hide' : 'Edit'}
        </Button>
      </div>
      {isOpen && (
        <div className={styles.content}>
          <FormGroup>
            <LabeledTextArea
              label="Raw Text"
              size="large"
              isDisabled={file.ignored}
              value={file.contents}
              onChange={(contents) => onChange({ ...file, contents })}
            />
            <LabeledMultiTextInput
              id="copyrights"
              label="Copyrights"
              size="large"
              isDisabled={file.ignored}
              values={file.copyrights || []}
              onChange={(copyrights) => onChange({ ...file, copyrights })}
            />
          </FormGroup>
        </div>
      )}
    </ListGroupItem>
  );
};

export default ManageNoticeFile;
